export const homeChains = [
  {
    name: 'Ethereum',
    value: 'ethereum',
    icon: require('@/assets/icons/ethw.avif'),
  },
  {
    name: 'Polygon',
    value: 'matic',
    icon: null,
    iconFont: 'icon-Polygon-24',
  },
  {
    name: 'Tezos',
    value: 'tezos',
    icon: require('@/assets/icons/tezosw.avif'),
  },
  {
    name: 'Optimism',
    value: 'optimism',
    icon: null,
    iconFont: 'icon-OP-93',
  },
  {
    label: 'Arbitrum',
    name: 'Arbitrum',
    value: 'arbitrum',
    icon: null,
    iconFont: 'icon-Arbitrum-01',
  },
  {
    label: 'BNB',
    name: 'BNB',
    value: 'bsc',
    icon: null,
    iconFont: 'icon-BNB-01',
  },
];

export const homeTypes = [
  {
    name: 'NFT DAO',
    value: '0',
  },
  {
    name: 'DeFi DAO',
    value: '1',
  },
];
